module.exports = __webpack_public_path__ + "assets/2.bc16af75.svg";